import {
    ADD_TO_PURCHASE,
    REMOVE_FROM_PURCHASE,
    UPDATE_PURCHASE,
    CHANGE_VIEW,
    SET_USER_INFO,
    GET_ALL_DONATIONS,
    GET_DONATION_TYPES,
    REMOVE_PURCHASE_ITEM,
    GET_ALL_TRANSACTIONS,
    GET_TRANSACTION_DETAILS,
    RESET_VIEW,
    UPDATE_COST_ACTION,
    PURCHASE_LOADING,
    SET_ALERT
} from '../../Actions/Admin/ManagePurchaseAndRenewalsActions';

const initialState = {
    view: "CheckUser",
    userInfo: {},
    purchaseList: [],
    totalAmount: 0,
    editingPurchase: {},
    allDonations: [],
    transactionList: [],
    transactionDetails: null,
    purchaseLoading: false,
    visible: false,
    message: "",
    color: ""
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_PURCHASE:
            var amount = 0;

            for (var i = 0; i < state.purchaseList.length; i++) {
                let purchase = state.purchaseList[i];
                amount = Number(Number(purchase.SuggestedCost) + Number(amount));
            }

            return {
                ...state,
                purchaseList: [...state.purchaseList, action.payload],
                totalAmount: amount
            };
        case REMOVE_FROM_PURCHASE:
            return {
                ...state,
                purchaseList: state.purchaseList.filter(item => item !== action.payload),
            };
        case UPDATE_PURCHASE:
            var newList = state.purchaseList.map(item => {
                // Find the item with the matching id
                if (item.id === action.payload.id) {
                    // Return a new object
                    return (
                        action.payload
                    )
                }

                // Leave every other item unchanged
                return item;
            });
            var totalAmount = 0;
            var amount = newList.forEach(function (purchase) {
                totalAmount = Number(Number(purchase.SuggestedCost) + Number(totalAmount));
            });
            return {
                ...state,
                purchaseList: newList,
                totalAmount: amount
            };
        case CHANGE_VIEW:
			return {
				...state,
                view: action.payload.view,
                editingPurchase: action.payload
            };
        case GET_ALL_DONATIONS:
                return {
                    ...state,
                    allDonations: action.payload
                };           
        case SET_USER_INFO:
            return {
                ...state,
                userInfo: {
                    ...action.payload,
                    stateId: action.payload.state ? action.payload.state.id : 0
                }
            };
        case GET_DONATION_TYPES:
                return {
                    ...state,
                    donationTypes: action.payload
            };
        case REMOVE_PURCHASE_ITEM:
            return {
                ...state,
                purchaseList: state.purchaseList.filter(item => item.id !== action.payload),
                view: state.view
            };
        case GET_ALL_TRANSACTIONS:
            return {
                ...state,
                transactionList: action.payload
            };
        case RESET_VIEW:
            return {
                ...initialState,
                transactionList: action.payload
            }; 
        case GET_TRANSACTION_DETAILS:
            return {
                ...state,
                transactionDetails: action.payload
            };
        case PURCHASE_LOADING:
            return {
                ...state,
                purchaseLoading: action.payload
            };
        case UPDATE_COST_ACTION:

            const index = state.purchaseList.findIndex(({ id }) => id === action.payload.id);
            const newPurchaseItem = state.purchaseList;
            newPurchaseItem[index].SuggestedCost = Number(action.payload.SuggestedCost);
            newPurchaseItem[index].ActualCost = Number(action.payload.ActualCost);

            //console.log(newPurchaseItem[action.payload.id], "oldObject");
            //console.log(action.payload, "newObject");

            //console.log(state.purchaseList, "oldPurchaseList");
            //console.log(newPurchaseItem, "newPurchaseList");
            return {
                ...state,
                purchaseList: newPurchaseItem
            };
        case SET_ALERT:
            return {
                ...state,
                visible: action.visible,
                message: action.message,
                color: action.color
            };     
		default:
			return state;
	}
};